module.exports = __webpack_public_path__ + "static/img/AM.7001ada5.svg";